import Vue from 'vue'
import Vuetify from 'vuetify'
import VModal from 'vue-js-modal' //todo drop
// import {Button, Select, Input, Dialog, Form, FormItem, Option, Switch, Row, Col, Card, Tree, Container} from 'element-ui'
// import lang from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale'
import axios from 'axios'
import permissionsPlugin from '../plugins/permissions'


import './config'
import { router } from '../router/router'
import { store } from '../store/store'

import englishLng from '../languages/English.js'
import DataProcessor from '../store/dataProcessor'

import storeActions from '../store/actions'
import techVisitActions from './tech_visits/techVisitActions'
import '../env/lodash'
import { findByKey } from '../helpers/index'
import '../helpers/versionChecker'
import NotificationBudger from '../helpers/notificationBadger';

// globals
import timeTz from '../globals/timeTz'
import clear from '../globals/clear'
import noRecordsFound from '../globals/noRecordsFound'
import locationButtons from '../globals/locationButtons'
import loader from '../globals/loader'
import deviceLink from '../globals/deviceLink'
import mobile from '../globals/mobile'

// components
import filterField from '../components/filter/filterField'
import filterFieldDevices from '../components/filter/filterFieldDevices'
import filterFieldLocations from '../components/filter/filterFieldLocations'
import filterFieldApplications from '../components/filter/filterFieldApplications'
import orderField from '../components/filter/orderField'
import jsonView from '../components/json/jsonView'
import circleStatus from '../components/circleStatus'
import tabs from '../components/tabs'
import materialTabs from '../components/materialTabs'
import jsonEditor from '../components/jsonEditor'


// styles
import 'vuetify/dist/vuetify.min.css'
import '../styles/admin.css'
import '../styles/admin-lib-fix.css'
import '../styles/coin-graph.css'
import '../styles/components.css'
import '../styles/jsoneditor.min.css'
import '../styles/map-styles.css'
import '../styles/scrollup.css'
import '../styles/sso.css'
import '../styles/zlib_imageviewer.css'
import '../styles/zlib_jstree.css'
import '../_styles/layout.css'
import '../styles/layout.css'
import '../styles/global.css'
// import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Vuetify)
Vue.use(VModal)
// locale.use(lang)
// Vue.use(Button)
// Vue.use(Select)
// Vue.use(Input)
// Vue.use(Dialog)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Option)
// Vue.use(Switch)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Card)
// Vue.use(Tree)
// Vue.use(Container)


Vue.use(permissionsPlugin)
Vue.config.performance = true

Vue.use({
  install (vue, _options) {
    const dataApi = axios.create({
      baseURL: config.apiAdminUrl
      // timeout: 10000,
    })
    vue.prototype.confirm = (elem, options = {}) => {
      let successAlert = elem.modalSettings.successAlert = options.successAlert
      let question = elem.modalSettings.modalQuestion = options.question
      let actionName = elem.modalSettings.actionName = options.actionName
      let isModalOpen = elem.modalSettings.showModal = !elem.modalSettings.showModal
      return isModalOpen, question, actionName, successAlert
    }

    vue.prototype.resubscribe = async function () {
      socketWatcherResubscribe();
    }

    vue.prototype.subscribe = async function (name, options = {all: true}, cb) {
      this.$store.commit('subStart', name)
      try {
        const dummyMapper = { //todo rework
          logs: 'viewLogs',
          payment_comments: 'viewPaymentComments',
          dispensed_notes: 'viewDispensed',
          customer_referrals: 'viewReferrals',
          'b2b_twilio.conversations': 'smsChat',
          sessions: 'sessions',
          customer_comments: 'customerComments',
          payment_assets: 'viewTransactionAssets',
          atm_extractions: ['cashDispenserExtractions', 'showATMCashLoading'],
          extractions: ['billAcceptor', 'cash'],
          tech_visit_comments: 'techVisitComments',
          terminals: ['showTerminals', 'showDispenser'],
          tech_visit_extractions: 'showDispenserHistory',
          device_settings: 'showSettings',
          device_dispenser_changes: 'showDispenser',
          tech_visit_deposits: 'showDispenserHistory',
          payments_stats: 'showAnalytics',
          transfers: 'showACHTransfers',
          total_clerk_payments: 'manageClerks'
        }

        let checkPermissionName = name

        if (checkPermissionName.indexOf('log') > -1) {
          checkPermissionName = 'logs'
        }

        if (dummyMapper[checkPermissionName]) {
          let allowQuery = false
          const permissions = this.$user.permissions
          // const existingKey = findByKey(permissions, dummyMapper[checkPermissionName])
          const checkPermissions = dummyMapper[checkPermissionName]

          let existingKey = null

          if (_.isArray(checkPermissions)) {
            for (let i = 0; i < checkPermissions.length; i++) {
              const permission = checkPermissions[i]
              existingKey = findByKey(permissions, permission)

              if (existingKey) {
                break
              }
            }
          } else {
            existingKey = findByKey(permissions, checkPermissions)
          }

          if (!_.isNull(existingKey)) {
            allowQuery = existingKey

            if (!allowQuery) {
              return
            }
          }
        }

        if (_.isFunction(options)) {
          cb = options
          options = {}
        }

        console.log('subscribe', name, options);
        // const dataProcessor = new DataProcessor(this.$store)
        //
        // const params = {}
        // _.each(options, (v, k) => {
        //   params[k] = JSON.stringify(v)
        // });
        //
        // const res = await dataApi(name, {
        //   params: params,
        //   headers: {Authorization: store.state.access_token}
        // })
        // const responseData = res.data
        //
        // console.log('res', name, responseData)
        // // const arrPrev = _.filter(this.$store.state[name], item => {
        // //   if (ids.includes[item._id]) return true
        // //   this.$store.dispatch(this.storeActions.STORE_ITEM_REMOVE, { collection: name, id: item._id })
        // //   return false
        // // })
        //
        // this.$store.dispatch(this.storeActions.STORE_RESET_COLLECTION, {collection: name})
        //
        // const ids = []
        //
        // responseData.forEach(item => {
        //   // const prevItem = _.find(arrPrev, { _id: item._id })
        //   // if (!prevItem) {
        //   // this.$store.dispatch(this.storeActions.STORE_ITEM_CREATE, { collection: name, id: item._id, object: item })
        //   // } else {
        //   //   this.$store.dispatch(this.storeActions.STORE_ITEM_REPLACE, { collection: name, id: item._id, object: item })
        //   // }
        //   if (!item.id) {
        //     item.id = item._id
        //   }
        //
        //   ids.push(item.id)
        //
        //   dataProcessor.process(name, item)
        // })
        //
        // this.$store.dispatch(storeActions.STORE_BULK_INSERT_DATA, {collection: name, data: responseData})
        //
        // this.$store.commit('subEnd', name)

        const payload = {
          collection: name,
          options
        }
        console.log('create subscription', payload)
        await socketWatcherSubscribe(payload)
        if (_.isFunction(cb)) cb()
      } catch (e) {
        console.error('Subscription error ', e)
      }
      this.$store.commit('subEnd', name)
    }
  }
})

Vue.use({
  install () {
    Vue.prototype.lang = englishLng
    Vue.prototype.storeActions = storeActions

    // alerts
    Vue.prototype.alertSuccess = function (...args) {
      alertify.success(...args)
    }
    Vue.prototype.alertError = function (data) {
      console.error('alertError', data)
      let displayText = data
      if (_.isObject(data) && data.message) displayText = data.message;
      else if (_.get(data, 'response.data.errors')) displayText = _.get(data, 'response.data.errors');
      else if (_.get(data, 'data.errors')) displayText = _.get(data, 'data.errors');
      else if (_.get(data, 'errors')) displayText = _.get(data, 'errors');
      else if (_.isEmpty(displayText)) displayText = 'Something Wrong';
      alertify.error(displayText.toString())
    }

    Vue.prototype.createAlertCallback = function (successMessage, next, catchError) {
      return (err, data) => {
        if (err) {
          catchError && catchError(err)
          return this.alertError((err.response && err.response.data) || err);
        }
        this.alertSuccess((data && data.message) || successMessage)
        if (_.isFunction(next)) next(data)
      }
    }

    Vue.prototype.createErrorOnlyCallback = function (errorMessage) {
      return (err) => {
        if (err) return this.alertError(errorMessage || err)
      }
    }
  }
})

Vue.use({
  install () {
    Vue.prototype.storeInsertItem = function (collection, id, object) {
      this.$store.dispatch(storeActions.STORE_ITEM_CREATE, { collection, id, object })
    }
    Vue.prototype.storeUpdateItem = function (collection, id, changes) {
      this.$store.dispatch(storeActions.STORE_ITEM_REPLACE, { collection, id, changes })
    }
    Vue.prototype.storeRemoveItem = function (collection, id) {
      this.$store.dispatch(storeActions.STORE_ITEM_REMOVE, { collection, id })
    }
    Vue.prototype.techVisitActions = techVisitActions
  }
})

Vue.use({
  install () {
    Vue.prototype.modals = {}
    Vue.prototype.techVisitActions = techVisitActions
  }
})

Vue.use({
  install () {
    const badger = new NotificationBudger({size: 0.7, position: 'nw'});
    window.NOTIFICATION_COUNT = 0;
    let blink = 0;


    const popsound = new Audio('https://gget.it/u1urz3zh/popsound.mp3');
    popsound.load();

    Vue.prototype.setPaymentsToReview = (payments) => {
      var lastPayment = payments[0];
      var count = payments.length;
      var prevCount = window.NOTIFICATION_COUNT;
      window.NOTIFICATION_COUNT = count;

      if (prevCount < count) {
        var msg = alertify.success(`New payment on review ${lastPayment.payment_id}`);
        msg.callback = ((isClicked) => {
          if (isClicked) {
            router.push({path: '/transaction/' + lastPayment.payment_id})
          }
        });
      };

    };

    setInterval(() => {
      const val = Math.min(99, parseInt(window.NOTIFICATION_COUNT, 10))

      badger.value = blink ? window.NOTIFICATION_COUNT : 0;
      blink = blink ? 0 : 1;
      if (!!val) popsound.play();
    }, 1000)
  }
})

Vue.mixin(mobile)

Vue.component('clear', clear)
Vue.component('time-tz', timeTz)
Vue.component('json-view', jsonView)
Vue.component('noRecordsFound', noRecordsFound)
Vue.component('locationButtons', locationButtons)
Vue.component('filterField', filterField)
Vue.component('filterFieldDevices', filterFieldDevices)
Vue.component('filterFieldLocations', filterFieldLocations)
Vue.component('filterFieldApplications', filterFieldApplications)
Vue.component('orderField', orderField)
Vue.component('tabs', tabs)
Vue.component('materialTabs', materialTabs)
Vue.component('circleStatus', circleStatus)
Vue.component('jsonEditor', jsonEditor)
Vue.component('loader', loader)
Vue.component('device-link', deviceLink)

const vm = new Vue({ // todo reworked later
  el: '#vue-root',
  router,
  store,
  template: '<router-view />',
  created () {
    window.store = store
    this.$store.dispatch('createDataProcessor')

    // const token = localStorage.getItem('token')
    // this.$store.commit('setToken', token)

    window.addEventListener('storage', (e) => {
      if (e.key === 'token') {
        this.$store.commit('setToken', e.newValue)
      }
    })
  }
})

window.Vue = vm



// WEBPACK FOOTER //
// ./src/templates/vue.js